import React from 'react'
import { ClinTheme } from '../../../../ClinTheme'
import { ClinText } from '../../../../components/ClinText'
import {
  CatalogueItemConstants,
  getTooltipTranslation
} from '../ProductVariant.models'
import StatusTooltip from '../../../Patients/PatientDashboard/StatusTooltip'
import { StyledStatusContainer } from './StatusColumn.styles'

interface CatalogueItemStatusComponent {
  availableQuantity: string | undefined
  catalogueItemStatus: string
}

const StatusColumn: React.FC<CatalogueItemStatusComponent> = ({
  availableQuantity,
  catalogueItemStatus
}) => {
  const statusColors: {
    [key: string]: { backgroundColor: string; textColor: string }
  } = {
    [CatalogueItemConstants.InStock]: {
      backgroundColor: ClinTheme.colors.paleMint,
      textColor: ClinTheme.colors.deepGreen
    },
    [CatalogueItemConstants.BackOrder]: {
      backgroundColor: ClinTheme.colors.palePink,
      textColor: ClinTheme.colors.darkRed
    },
    [CatalogueItemConstants.RequestQuote]: {
      backgroundColor: ClinTheme.colors.lightViolet,
      textColor: ClinTheme.colors.primaryMid
    },
    [CatalogueItemConstants.OutOfStock]: {
      backgroundColor: ClinTheme.colors.warmBeige,
      textColor: ClinTheme.colors.black
    },
    [CatalogueItemConstants.Unavailable]: {
      backgroundColor: ClinTheme.colors.grey,
      textColor: ClinTheme.colors.darkGrey
    }
  }

  const quantity = Number(availableQuantity)
  const isPacksAvailable = quantity > 0

  const packsTitle = isPacksAvailable
    ? `${quantity} pack${quantity === 1 ? '' : 's'}`
    : catalogueItemStatus

  const { backgroundColor, textColor } = isPacksAvailable
    ? statusColors[CatalogueItemConstants.InStock]
    : statusColors[catalogueItemStatus] || {
        backgroundColor: 'rgba(117, 117, 117, 0.1)',
        textColor: ClinTheme.colors.darkGrey
      }

  const renderStatusContent = (backgroundColor: string, textColor: string) => (
    <StyledStatusContainer backgroundColor={backgroundColor}>
      <ClinText
        whiteSpace="nowrap"
        fontWeight={ClinTheme.fontWeights.medium}
        color={textColor}
        textAlign="center"
        fontSize={ClinTheme.fontSizes[0]}
        lineHeight={ClinTheme.lineHeights.largeParagraph}
        display="flex"
      >
        {packsTitle}
      </ClinText>
    </StyledStatusContainer>
  )

  return (
    <StatusTooltip tooltipText={getTooltipTranslation(catalogueItemStatus)}>
      {renderStatusContent(backgroundColor, textColor)}
    </StatusTooltip>
  )
}

export default StatusColumn
